import React, { useEffect, useState } from 'react'
import FeatherIcon from 'feather-icons-react';
import { Container } from 'react-bootstrap';
import { setGlobalLoading } from 'redux/actions/actionCommon';
import { connect } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import Step1 from './Includes/Step1';
import Step2 from './Includes/Step2';
import useStoreUrl from 'utlis/CustomHooks/useStoreUrl';

function AddDelivery(props) {
    const [loading, setLoading] = useState(true)
    const [goSteps, setGoSteps] = useState(0);

    // store url
    const [storeUrl] = useStoreUrl()

    // consts
    const TOTAL_STEPS = 2
    const history = useHistory()

    useEffect(() => {
        setLoading(true)
        setTimeout(() => {
            setLoading(false)
        }, 1000);
    }, [props.currentUser.token, props])

    // handle go back
    const handleGoBack = (ev) => {
        ev.preventDefault()

        console.log("goSteps ", goSteps);

        if(goSteps === 0) {
            history.push(storeUrl + "/settings/shippings") // moving back
        }

        if(goSteps === 1) {
            setGoSteps(0) // opening step 0
        }
    }

    return (
        <section
            id="app-saleOrders__create-details"
            className="st-def-mar-TB">
            <Container fluid className="st-container">
                <div className="app-saleOrders__create-details">
                    <div className="app-header-wrapper mb-4">
                        <div className="back-button-wrapper mb-2">
                            <div
                                className="text-decoration-none st-text-primary d-inline-flex align-items-center cursor-pointer st-fs-15" onClick={handleGoBack}>
                                <FeatherIcon
                                    icon="arrow-left"
                                    size="14"
                                    className="icon me-1" />
                                <span>Back</span>
                            </div>
                        </div>
                        <p className="app-heading text-capitalize">New Shipping Method</p>
                    </div>
                    <div
                        className="sale-content-container">
                        {/* progress indicator */}
                        <div className="progress-indicator mb-3">
                            {
                                (goSteps === 0) ? (
                                    <>
                                        <div className="text st-fw-600 st-fs-17 mb-2">
                                            <span className="st-text-success me-2 st-text-color">
                                                Step 1 from {TOTAL_STEPS}.
                                            </span>
                                            <span>Set up rates for Local delivery</span>
                                        </div>

                                        {/* progress bar */}
                                        <div className={`progress-main ${(goSteps === 0) ? "step-1" : ""}`}>
                                            <div className="inner" style={{width: "33.3%"}}></div>
                                        </div>
                                    </>
                                ) : null
                            }
                            {
                                (goSteps === 1) ? (
                                    <>
                                        <div className="text st-fw-600 st-fs-17 mb-2">
                                            <span className="st-text-success me-2 st-text-color">
                                                Step 2 from {TOTAL_STEPS}.
                                            </span>
                                            <span>Set up free delivery</span>
                                        </div>

                                        {/* progress bar */}
                                        <div className={`progress-main ${(goSteps === 2) ? "step-2" : ""}`}>
                                            <div className="inner" style={{width: "66.6%"}}></div>
                                        </div>
                                    </>
                                ) : null
                            }
                        </div>

                        {/* hiding the previous section - START */}
                        <div className="sale-order-steps d-none">
                            <div className="sale-order-stepper">
                                <div className="stepper-container">
                                    <div className="stepper-step">
                                        <button className={`${goSteps === 0 ? "active" : "completed"}`}
                                            onClick={(e => {
                                                if (goSteps > 0) {
                                                    setGoSteps(0)
                                                }
                                            })}

                                        >
                                            <span className="stepper-label">
                                                {goSteps === 0 ? "1" :
                                                    <FeatherIcon
                                                        icon="check"
                                                        size="18"
                                                        className="icon position-relative"
                                                        style={{ strokeWidth: 4 }}
                                                    />}
                                            </span>
                                        </button>
                                        <div className={`stepper-title ${goSteps === 0 ? "active" : "completed"}`}>
                                            <span className="step-label" style={{ fontFamily: 'Source Sans Pro, sans-serif' }}>
                                                Set up rates for Local delivery
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <div className="stepper-container">
                                    <div className="vertical-border active">
                                        <span className={`center-border ${goSteps === 0 ? "active" : "completed"}`}></span>
                                    </div>
                                    <div className="stepper-step">
                                        <button className={`${goSteps > 1 ? "completed" : goSteps !== 0 ? "active" : goSteps === 0 ? "" : ""}`}
                                            onClick={(e => {
                                                if (goSteps > 1) {
                                                    setGoSteps(1)
                                                }
                                            })}
                                        >
                                            <span className="stepper-label">
                                                {
                                                    goSteps > 1 ? <FeatherIcon
                                                        icon="check"
                                                        size="18"
                                                        className="icon position-relative"
                                                        style={{ strokeWidth: 4 }}
                                                    /> :
                                                        goSteps !== 0 ? "2" :
                                                            goSteps === 0 ? "2" : ""
                                                }

                                            </span>
                                        </button>
                                        <div className={`stepper-title ${goSteps > 1 ? "completed" : goSteps !== 0 ? "active" : goSteps === 0 ? "" : ""}`}>
                                            <span className="step-label " style={{ fontFamily: 'Source Sans Pro, sans-serif' }}>Set up free delivery</span>
                                        </div>
                                    </div>
                                </div>


                            </div>
                        </div>
                        {/* hiding the previous section - FINISH */}

                        {goSteps === 0 && (
                            <Step1
                                goSteps={goSteps}
                                setGoSteps={setGoSteps}
                            />
                        )}
                        {goSteps === 1 && (
                            <Step2
                                goSteps={goSteps}
                                setGoSteps={setGoSteps}
                            />
                        )}
                    </div>
                </div>
            </Container >
        </section >
    )
}


const getDataFromStore = state => {
    return {
        currentUser: state.auth.currentUser,
        sideBarVisibility: state.common.sideBarVisibility
    };
}

const dispatchActionsToProps = dispatch => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(AddDelivery)